<!-- eslint-disable no-empty -->
<template>
  <div class="page page-add">
    <div class="page-container">
      <div class="page-title" v-if="meetingId">编辑会议</div>
      <div class="page-title" v-else>新增会议</div>
      <div class="w1000">
        <div class="panel">
          <a-form-model ref="form" :model="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }" class="form-class">
            <h3 class="text-center v-mb-md">会议基本信息</h3>
            <div class="panel-body">
              <!-- <a-divider class="bg-primary"></a-divider> -->
              <a-row :gutter="0">
                <a-col span="24">
                  <a-form-model-item :colon="false" prop="meetingTitle" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      会议主题
                    </span>
                    <a-input placeholder="会议主题" allowClear v-model="form.meetingTitle" ref="meetingTitle" />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="0">
                <a-col span="12">
                  <a-form-item :colon="false">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      会议时间
                    </span>
                    <a-range-picker show-time v-model="form.dates" :placeholder="['开始时间', '结束时间']" size="default" style="width: 300px" @change="onDateRangeChange" ref="datePicker" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" />
                  </a-form-item>
                </a-col>
                <!-- <a-col span="12">
                  <a-form-model-item :colon="false">
                    <span slot="label">
                      <i class="required-mark"></i>
                      会议方式
                    </span>
                    <a-select placeholder="选择会议方式" v-model="form.meetingType" style="width: 100%" allowClear ref="meetingType">
                      <a-select-option value="视频会议">视频会议</a-select-option>
                      <a-select-option value="现场会议">现场会议</a-select-option>
                      <a-select-option value="其他">其他</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col> -->
              </a-row>
              <a-row :gutter="0">
                <a-col span="12">
                  <a-form-model-item :colon="false">
                    <span slot="label">
                      <i class="required-mark"></i>
                      会议方式
                    </span>
                    <a-select placeholder="选择会议方式" v-model="form.meetingType" style="width: 300px" allowClear ref="meetingType">
                      <a-select-option value="视频会议">视频会议</a-select-option>
                      <a-select-option value="现场会议">现场会议</a-select-option>
                      <a-select-option value="其他">其他</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col span="12" v-if="form.meetingType == '视频会议'">
                  <a-form-model-item :colon="false" prop="meetingCode">
                    <span slot="label">腾讯视频会议号</span>
                    <a-input type="number" placeholder="视频会议号" allowClear v-model="form.meetingCode" ref="meetingCode" />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="0">
                <a-col span="24">
                  <a-form-model-item :colon="false" label="参会专家" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                    <template v-if="expertList.length > 0">
                      <div class="flex items-center" v-for="(item, index) in expertList" :key="index">
                        <div style="width: 500px">
                          <a-input-group compact>
                            <a-select placeholder="选择专家" style="width: 350px" @change="onExpertChange(item)" show-search allow-clear v-model="item.id" :ref="`expertList${index}`">
                              <a-select-option :disabled="expertList.some(d => d.id == item.id)" v-for="item in allExperts" :key="item.id">{{ item.realName }}</a-select-option>
                            </a-select>
                            <a-input type="number" disabled style="width: 150px" placeholder="专家手机号" v-model="item.phone" :ref="`addr-${index}`" />
                          </a-input-group>
                        </div>
                        <a-space class="v-ml-sm">
                          <a-button size="small" type="primary" icon="plus" @click="onAddExpert(index + 1)"></a-button>
                          <a-button size="small" type="default" icon="close" @click="onRemoveExpert(index)"></a-button>
                        </a-space>
                      </div>
                    </template>
                    <a-button size="small" type="primary" icon="plus" @click="onAddExpert(0)" v-else>添加专家</a-button>
                    <!-- <a-button size="small" type="primary" icon="plus" @click="onAddExpert(0)" v-else>添加专家</a-button> -->
                    <div v-if="expertList.length > 0">
                      <a-checkbox v-model="form.isSendMessage">发布会议时同步短信通知专家</a-checkbox>
                    </div>
                  </a-form-model-item>
                </a-col>
                <a-col span="24">
                  <a-form-model-item :colon="false" prop="otherParticipant" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                    <span slot="label">美丽心灵参会人员</span>
                    <!-- <a-input placeholder="美丽心灵参会人员" allowClear v-model="form.otherParticipant" ref="otherParticipant" /> -->
                    <a-select v-model="form.staffs" mode="multiple" placeholder="美丽心灵参会人员" labelInValue>
                      <a-select-option v-for="item in unselectedStaffs" :key="item.id" :title="item.realName" :label="item.realName">
                        {{ item.realName }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="0">
                <a-col span="24">
                  <a-form-model-item :colon="false" label="外部参会人员" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                    <template v-if="externalList.length > 0">
                      <div class="flex items-center" v-for="(item, index) in externalList" :key="index">
                        <div style="width: 500px">
                          <a-input-group compact>
                            <a-select placeholder="外部参会人员" mode="combobox" style="width: 350px" @change="onExternalMemberChange(item)" show-search allow-clear v-model="item.memberName" :ref="`externalList${index}`">
                              <a-select-option :disabled="externalList.some(d => d.memberName == user.memberName)" v-for="user in allExternalMembers" :key="user.memberName">{{ user.memberName }}</a-select-option>
                            </a-select>
                            <a-input type="number" style="width: 150px" placeholder="手机号" v-model="item.phone" :ref="`addr-${index}`" />
                          </a-input-group>
                        </div>
                        <a-space class="v-ml-sm">
                          <a-button size="small" type="primary" icon="plus" @click="onAddExternalMember(index + 1)"></a-button>
                          <a-button size="small" type="default" icon="close" @click="onRemoveExternalMember(index)"></a-button>
                        </a-space>
                      </div>
                    </template>
                    <a-button size="small" type="primary" icon="plus" @click="onAddExternalMember(0)" v-else>添加外部参会人员</a-button>
                    <div v-if="externalList.length > 0">
                      <a-checkbox v-model="form.isSendMessageExternal">发布会议时同步短信通知外部参会人员</a-checkbox>
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col>
                  <a-form-model-item :colon="false" prop="meetingRemark" label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                    <a-textarea v-model="form.meetingRemark" placeholder="会议备注" :rows="4" style="width: 100%" />
                  </a-form-model-item>
                </a-col>
                <a-col>
                  <a-form-item :colon="false" prop="meeting_resource" label="会议附件" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                    <a-upload-dragger
                      :action="`${baseURL}/file/upload`"
                      :data="{
                        params: JSON.stringify({ fileMark, fileBelongId: meetingId, fileType: 9, fileSign: 'PM' }),
                      }"
                      :show-upload-list="{
                        showPreviewIcon: true,
                        showRemoveIcon: true,
                        showDownloadIcon: true,
                      }"
                      :file-list="files"
                      :before-upload="beforeUploadFile"
                      @change="handleUploadChange"
                      @download="({ fileId, name }) => downloadFile({ fileId, fileSign: 'PM', fileName: name })"
                      accept=".pdf, .doc, .docx, .xls, .xlsx, .txt"
                    >
                      <div class="v-pa-xs">
                        <a-icon type="plus" />
                        <p class="font-xs">点击选择或拖拽文件至此区域(支持pdf,word,excel,txt)</p>
                      </div>
                    </a-upload-dragger>
                  </a-form-item>
                </a-col>
                <a-col>
                  <a-form-model-item :colon="false" prop="meetingRemark" label="所属项目" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                    <a-select :disabled="!!projectId" v-model="form.projectId" placeholder="选择项目" option-label-prop="label" :filter-option="filterOption" show-search allow-clear>
                      <a-select-option v-for="item in projects" :key="item.id" :label="item.name">
                        <div class="flex items-center">
                          <div class="col ellipsis">{{ item.name }}</div>
                          <div class="v-ml-auto">
                            <a-tag class="tag-tiny" color="#3f51b5" v-if="item.type === 11">公募合作</a-tag>
                            <a-tag class="tag-tiny" color="#3f51b5" v-else-if="item.type === 12">专项基金</a-tag>
                            <a-tag class="tag-tiny" color="#3f51b5" v-else-if="item.type === 21">螺蛳壳改造</a-tag>
                            <a-tag class="tag-tiny" color="#3f51b5" v-else-if="item.type === 22">精灵书屋</a-tag>
                            <a-tag class="tag-tiny" color="#3f51b5" v-else-if="item.type === 23">公益人才</a-tag>
                            <a-tag class="tag-tiny" color="#3f51b5" v-else-if="item.type === 24">爱心100</a-tag>
                            <a-tag class="tag-tiny" color="#3f51b5" v-else-if="item.type === 25">其他项目</a-tag>
                          </div>
                        </div>
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
          </a-form-model>
          <a-form-model :label-col="{ span: 8 }" :wrapper-col="{ span: 15 }" class="form-class">
            <div class="panel">
              <h3 class="text-center v-mb-md">投票主题</h3>
              <!-- <a-button size="small" type="primary" icon="plus" @click="onAddVote" style="margin-left: 85%">添加投票主题</a-button> -->
              <div class="panel-body">
                <a-form-model-item :colon="false">
                  <span slot="label"></span>
                  <div class="text-right">
                    <a-button size="small" type="primary" icon="plus" @click="onAddVote">添加投票主题</a-button>
                  </div>
                </a-form-model-item>
                <div v-for="(item, index) in voteList" :key="index">
                  <a-divider v-if="index > 0"></a-divider>
                  <a-row :gutter="0">
                    <a-col span="24">
                      <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                        <span slot="label">
                          <i class="required-mark">*</i>
                          投票主题名称
                        </span>
                        <a-input placeholder="投票主题名称" allowClear v-model="item.title" :ref="`voteTitle-${item.uid}`" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col span="12">
                      <a-form-model-item :colon="false">
                        <span slot="label">
                          <i class="required-mark">*</i>
                          投票类型
                        </span>
                        <a-select placeholder="选择会议方式" v-model="item.voteType" style="width: 100%" allowClear ref="voteType" @change="updateOptions(item)">
                          <a-select-option :value="0">同意/反对/弃权(单选)</a-select-option>
                          <a-select-option :value="1">动态配置投票选项</a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col span="12" v-if="item.voteType === 1">
                      <a-form-model-item :colon="false" :label-col="{ span: 10 }" :wrapper-col="{ span: 10 }">
                        <span slot="label">
                          <i class="required-mark">*</i>
                          每位专家最多可投票数
                        </span>
                        <a-input-number placeholder="票数" :min="1" allowClear v-model="item.maxNum" :ref="`maxNum-${item.uid}`" style="width: 100px" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col>
                      <a-form-model-item :colon="false" prop="description" label="投票详细描述" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                        <a-textarea :auto-size="{ minRows: 3 }" v-model="item.description" placeholder="详细描述" style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row v-if="item.voteType === 1">
                    <a-col span="24">
                      <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 10 }">
                        <span slot="label">
                          <i class="required-mark">*</i>
                          投票选项
                        </span>
                        <template v-if="item.options.length > 0">
                          <div class="flex items-center" v-for="(option, optionIndex) in item.options" :key="optionIndex">
                            <div style="width: calc(100% - 100px)">
                              <a-input placeholder="选项名称" v-model="option.content" :ref="`optionContent-${index}-${optionIndex}`" />
                            </div>
                            <a-space class="v-ml-sm">
                              <a-button size="small" type="primary" icon="plus" @click="onAddVoteOption(optionIndex + 1, item.options)"></a-button>
                              <a-button size="small" type="default" icon="close" @click="onRemoveVoteOption(optionIndex, item.options)" v-if="item.options.length > 2"></a-button>
                            </a-space>
                          </div>
                        </template>
                        <a-button class="v-mr-xs" size="small" type="primary" icon="plus" @click="onAddVoteOption(0, item.options)" v-if="item.options.length == 0">添加投票选项</a-button>
                        <div class="flex items-center">
                          <span class="line-normal text-grey">请至少输入2项</span>
                        </div>
                      </a-form-model-item>
                    </a-col>
                    <a-col span="12"></a-col>
                  </a-row>
                  <a-form-model-item :colon="false">
                    <span slot="label"></span>
                    <div class="text-right">
                      <a-space>
                        <!-- <a-button size="small" icon="save" type="indigo" @click="saveVote(index)">保存投票主题</a-button> -->
                        <a-button size="small" icon="delete" type="default" class="text-red" @click="onRemoveVote(index)">删除投票主题</a-button>
                      </a-space>
                    </div>
                  </a-form-model-item>
                </div>
              </div>
            </div>
          </a-form-model>
        </div>

        <a-affix :offset-bottom="10" :target="() => this.$refs.container">
          <div class="text-center v-mt-sm">
            <a-space>
              <a-button icon="check" type="primary" @click="handleConfirmUpdate(true)" v-if="record.meetingState == 1" :loading="saving">保存会议</a-button>
              <template v-else-if="!record.meetingId || record.meetingState == 0">
                <a-button icon="check" type="indigo" @click="handleConfirm(false)" :loading="saving">保存，暂不发布会议</a-button>
                <a-button icon="arrow-right" type="primary" @click="handleConfirm(true)" :loading="saving">保存并发布会议</a-button>
              </template>
              <a-button icon="left" type="default" @click="$router.go(-1)">返回</a-button>
            </a-space>
          </div>
        </a-affix>
      </div>
    </div>
  </div>
</template>

<script>
import { saveMeeting, getMeeting, updateMeeting, listExternalMembers } from '@/api/project/meeting'
import { listAccessable } from '@/api/project/common'
import { listApplicant } from '@/api/applicant'
import { listUser } from '@/api/system/user'

const form = {
  meetingId: undefined,
  projectId: undefined,
  meetingTitle: '',
  meetingState: 0,
  meetingType: undefined,
  meetingEndTime: '',
  meetingStartTime: '',
  meetingRemark: '',
  meetingCode: '',
  fileIds: [],
  maxNum: 1,
  otherParticipant: '',
  isSendMessage: false,
  isSendMessageExternal: false,
  expertIds: '',
  dates: [],
  experts: [],
  staffs: [],
  externalPersons: [],
  votes: [],
}

export default {
  data() {
    return {
      meetingId: undefined,
      projectId: undefined,
      form: { ...form },
      expertList: [],
      voteList: [],
      allExperts: [],
      staffs: [],
      selectedStaffs: [],
      voteFlag: true,
      files: [],
      record: {},
      fileMark: this.$utils.uuid(),
      externalList: [],
      allExternalMembers: [],
      projects: [],
      saving: false,
    }
  },
  computed: {
    unselectedStaffs() {
      return this.staffs.filter(d => !this.form.staffs.some(item => item.key == d.id))
    },
  },
  methods: {
    init() {
      let { id, pid } = this.$route.query
      if (id) {
        this.meetingId = +id
        this.loadMeeting()
      } else {
        this.onAddExpert(0)
        // this.onAddVote(0)
        this.onAddExternalMember(0)
        this.form.projectId = pid ? +pid : undefined
      }
      if (pid) {
        this.projectId = +pid
      }
      this.loadProjects()
      this.loadExpertList()
      this.loadInterUserList()
      this.loadExternalMembers()
    },
    loadMeeting() {
      getMeeting(this.meetingId).then(({ data }) => {
        if (data.success) {
          this.record = data.result
          let { projectId, isSendMessage, isSendMessageExternal, meetingStartTime, meetingEndTime, meetingRemark = '', meetingTitle, meetingType, meetingCode = '', otherParticipant = '', files = [], experts, votes, externalMembers, staffs = [] } = data.result
          this.form = {
            ...form,
            projectId,
            isSendMessage: isSendMessage == 1,
            isSendMessageExternal: isSendMessageExternal == 1,
            meetingStartTime,
            meetingEndTime,
            meetingCode,
            dates: meetingStartTime && meetingEndTime ? [meetingStartTime, meetingEndTime] : [],
            meetingRemark,
            meetingTitle,
            meetingType,
            otherParticipant,
            staffs: staffs.map(({ id, realName }) => ({ key: id, label: realName })),
          }
          this.files = files.map(file => ({
            uid: file.fileId,
            name: file.fileOriginName,
            status: 'done',
            fileSign: 'PM',
            ...file,
          }))
          if (votes && votes.length) {
            this.voteList = votes.map(d => ({
              uid: d.voteId,
              voteId: d.voteId,
              voteType: d.voteType,
              title: d.title,
              description: d.description,
              maxNum: d.maxNum,
              options: d.options,
            }))
          }
          if (experts && experts.length) {
            this.expertList = experts
          } else {
            this.onAddExpert(0)
          }
          if (externalMembers && externalMembers.length) {
            this.externalList = externalMembers.map(d => ({
              memberId: d.memberId,
              memberName: d.memberName,
              phone: d.phone,
            }))
          } else {
            this.onAddExternalMember(0)
          }
        }
      })
    },
    loadInterUserList() {
      let interUserParams = {
        pageSize: -1,
        state: [1],
      }
      listUser(interUserParams).then(({ data }) => {
        if (data.success) {
          let { records = [] } = data.result
          this.staffs = records
        }
      })
    },
    loadExternalMembers() {
      listExternalMembers(undefined).then(({ data }) => {
        if (data.success) {
          let records = data.result || []
          records.forEach(item => {
            let member = {}
            member.memberId = item.memberId
            member.memberName = item.memberName
            member.phone = item.phone
            this.allExternalMembers.push(member)
          })
        }
      })
    },
    loadExpertList() {
      listApplicant({ pageSize: -1, roles: ['U05', 'U06'], banned: 0 }).then(({ data }) => {
        if (data.success) {
          this.allExperts = data.result.records
        }
      })
    },
    loadProjects() {
      listAccessable().then(({ data }) => {
        if (data.success) {
          this.projects = data.result
        }
      })
    },
    onDateRangeChange(date) {
      let [meetingStartTime, meetingEndTime] = date
      this.form.meetingStartTime = meetingStartTime
      this.form.meetingEndTime = meetingEndTime
    },
    handleMore() {
      this.form = { ...form }
    },
    filterOption(input, option) {
      return option.componentOptions.propsData.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleConfirm(nextStep) {
      let { dates, meetingTitle } = this.form
      // let { expertList, voteList } = this
      this.$message.destroy()
      if (meetingTitle.trim() === '') {
        this.$message.warning('请输入会议主题')
        this.$refs.meetingTitle.focus()
        return
      }
      if (dates.length == 0) {
        this.$message.warning('请选择会议时间')
        this.$refs.datePicker.focus()
        return
      }
      // if (expertList.length == 0) {
      //   this.$message.warning('请确定参会专家')
      //   return
      // }
      // if (voteList.length == 0) {
      //   this.$message.warning('请添加投票主题')
      //   return
      // }
      // for (let i = 0; i < voteList.length; i++) {
      //   if (!this.validVote(voteList[i])) {
      //     return false
      //   }
      // }

      this.$confirm({
        title: nextStep ? '确认保存并发布会议？' : '确认保存会议草稿？',
        centered: true,
        onOk: () => {
          this.handleSubmit(nextStep)
        },
      })
    },
    handleConfirmUpdate(nextStep) {
      let { dates, meetingTitle } = this.form
      this.$message.destroy()
      if (meetingTitle.trim() === '') {
        this.$message.warning('请输入会议主题')
        this.$refs.meetingTitle.focus()
        return
      }
      if (dates.length == 0) {
        this.$message.warning('请选择会议时间')
        this.$refs.datePicker.focus()
        return
      }
      let { voteList } = this
      for (let i = 0; i < voteList.length; i++) {
        if (!this.validVote(voteList[i])) {
          return false
        }
      }

      this.$confirm({
        title: '确认保存会议？',
        centered: true,
        onOk: () => {
          this.handleUpdate(nextStep)
        },
      })
    },
    handleSubmit(nextStep) {
      this.$message.destroy()
      let { meetingTitle, meetingType, meetingStartTime, meetingEndTime, meetingRemark, meetingCode, isSendMessage, isSendMessageExternal, staffs } = this.form
      let { meetingId, projectId, expertList, voteList, files, fileMark } = this
      let params = {
        meetingId,
        projectId: projectId || this.form.projectId,
        meetingTitle: meetingTitle.trim(),
        meetingType,
        meetingStartTime,
        meetingEndTime,
        meetingRemark: meetingRemark.trim(),
        meetingCode: meetingCode.trim(),
        isSendMessage: ~~isSendMessage,
        isSendMessageExternal: ~~isSendMessageExternal,
        votes: voteList,
        expertIds: expertList
          .filter(d => d.id)
          .map(d => d.id)
          .join(','),
        fileIds: files.map(d => d.fileId),
        fileMark,
        nextStep,
        externalMembers: this.externalList,
        otherParticipant: staffs.map(d => d.label).join(','),
        staffIds: staffs.map(d => d.key).join(','),
      }
      this.saving = true
      saveMeeting(params)
        .then(({ data }) => {
          this.saving = false
          if (data.success) {
            this.$message.success('操作成功')
            this.meetingId = data.result
            this.$router.go(-1)
          } else {
            this.$message.error('操作失败')
          }
        })
        .catch(() => {
          this.saving = false
          this.$message.error('操作失败')
        })
    },
    handleUpdate(nextStep) {
      this.$message.destroy()
      let { meetingTitle, meetingType, meetingStartTime, meetingEndTime, meetingRemark, meetingCode, isSendMessage, isSendMessageExternal, staffs } = this.form
      let { meetingId, projectId, expertList, externalList, voteList, files, fileMark } = this
      let params = {
        meetingId,
        projectId: projectId || this.form.projectId,
        meetingTitle: meetingTitle.trim(),
        meetingType,
        meetingStartTime,
        meetingEndTime,
        meetingRemark: meetingRemark.trim(),
        meetingCode: meetingCode.trim(),
        isSendMessage: ~~isSendMessage,
        isSendMessageExternal: ~~isSendMessageExternal,
        votes: voteList,
        // experts: expertList.map(d => d.userName),
        expertIds: expertList
          .filter(d => d.id)
          .map(d => d.id)
          .join(','),
        fileIds: files.map(d => d.fileId),
        externalMembers: externalList,
        otherParticipant: staffs.map(d => d.label).join(','),
        staffIds: staffs.map(d => d.key).join(','),
        fileMark,
        nextStep,
      }
      this.saving = true
      updateMeeting(params)
        .then(({ data }) => {
          this.saving = false
          if (data.success) {
            this.$message.success('操作成功')
            this.meetingId = data.result
            this.$router.go(-1)
          } else {
            this.$message.error('操作失败')
          }
        })
        .catch(() => {
          this.saving = false
          this.$message.error('操作失败')
        })
    },
    handleUploadChange(info) {
      this.files = this.handleUploadFile(info, -1)
    },
    onAddExpert(index = 0) {
      this.expertList.splice(index, 0, {
        id: undefined,
        userName: '',
        phone: '',
      })
    },
    onRemoveExpert(index) {
      this.expertList.splice(index, 1)
    },
    onAddExternalMember(index = 0) {
      this.externalList.splice(index, 0, {
        memberName: '',
        phone: '',
      })
    },
    onRemoveExternalMember(index) {
      this.externalList.splice(index, 1)
    },
    onExpertChange(record) {
      let user = this.allExperts.find(user => user.id == record.id)
      if (user) {
        record.phone = user.phone
      }
    },
    onExternalMemberChange(record) {
      let member = this.allExternalMembers.find(user => user.memberName == record.memberName)
      if (member) {
        record.phone = member.phone
        record.memberId = member.memberId
      }
    },
    onAddVote() {
      this.voteList.push({
        uid: Math.random(),
        title: '',
        voteType: 0,
        description: '',
        maxNum: 1,
        options: [
          { content: '同意', optionIndex: 0 },
          { content: '不同意', optionIndex: 1 },
          { content: '弃权', optionIndex: 2 },
        ],
      })
    },
    saveVote(index) {
      if (this.voteList[index].title.trim() === '') {
        this.$message.warning('请输入投票主题名称')
        return
      }
      if (this.voteList[index].voteType.trim() === '') {
        this.$message.warning('请选择投票类型')
        return
      }
      if (this.voteList[index].maxNum >= this.voteList[index].options.length) {
        this.$message.warning('投票张数必须小于选项个数')
        return
      }
    },
    validVote(item) {
      let { uid, title, voteType, maxNum, options } = item
      if (!title || title.trim() == '') {
        this.$message.warn('请输入投票主题名称')
        if (this.$refs[`voteTitle-${uid}`][0]) {
          this.$refs[`voteTitle-${uid}`][0].focus()
        }
        return false
      }
      if (voteType == 1) {
        let validOptions = options.filter(d => d.content.trim() != '')
        if (validOptions.length < 2) {
          this.$message.warning('动态投票选项个数不能少于2项')
          return false
        }
        if (maxNum > validOptions.length) {
          this.$message.warning('投票张数必须小于选项个数')
          this.$refs[`maxNum-${uid}`].focus()
          return false
        }
      }
      return true
    },
    onRemoveVote(index) {
      this.voteList.splice(index, 1)
    },
    onAddVoteOption(index = 0, options) {
      options.splice(index, 0, { content: '', optionIndex: index })
    },
    onRemoveVoteOption(index, options) {
      options.splice(index, 1)
    },
    updateOptions(vote) {
      if (vote.voteType == 0) {
        vote.options = [
          { content: '同意', optionIndex: 0 },
          { content: '不同意', optionIndex: 1 },
          { content: '弃权', optionIndex: 2 },
        ]
      } else if (vote.voteType == 1) {
        vote.options = [
          { content: '', optionIndex: 0 },
          { content: '', optionIndex: 1 },
        ]
      }
    },
  },
  created() {
    this.init()
  },
}
</script>

<style lang="stylus">
.form-class{
    background-color: #f4f4fa;
    padding: 20px;
    border-radius: 3px;
    margin-bottom: 20px;
}
</style>
